import {connect} from 'react-redux'
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";
import ProposedRoute from "../../Components/ProposedRoutes/ProposedRoute/ProposedRoute";

const mapStateToProps = (store) => {
    return {
        users: store.usersReducer.users,
        isEvaluatingDeliveryGroups: store.deliveryGroupsReducer.evaluatingProposedDeliveryGroups,
        assignedDeliveryGroups: store.deliveryGroupsReducer.assignedDeliveryGroups
    };
};

const mapDispatchToProps = {
    evaluateDeliveryGroups: deliveryGroupsActions.evaluateDeliveryGroupsAction,
    lockMessengerToGroup: deliveryGroupsActions.lockMessengerToGroup,
    unlockMessengerFromGroup: deliveryGroupsActions.unlockMessengerFromGroup,
    lockDeliveryGroup: deliveryGroupsActions.lockDeliveryGroup,
    unlockDeliveryGroup: deliveryGroupsActions.unlockDeliveryGroup,
    sendDeliveryGroup: deliveryGroupsActions.sendDeliveryGroupAction,
    fetchDeliveryGroups: deliveryGroupsActions.fetchAssignedDeliveryGroupsAction
};

const ProposedRouteContainer = connect(mapStateToProps, mapDispatchToProps)(ProposedRoute);

export default ProposedRouteContainer;